import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { catchError, of, take } from 'rxjs';
import { DocksModel } from 'src/app/models/DocksModel';
import { EmbalagemService } from 'src/app/services/embalagem/embalagem.service';

@Component({
  selector: 'app-view-emb',
  templateUrl: './view-emb.component.html',
  styleUrl: './view-emb.component.css'
})
export class ViewEmbComponent {

  config: boolean = false;
  dateInterval: any
  updateInterval: any
  embDocks: DocksModel[] = []
  dockId!: number
  selectedDock: number | any
  faFilter = faFilter

  constructor(
    private router: Router,
    private embService: EmbalagemService) {
  }

  ngOnInit() {
    this.updateData();
    this.dateInterval = setInterval(() => {
      this.updateData();
    }, 5000);
  }

  updateData(): void {
    this.embService.getEmbDocksDataView().pipe
      (take(1),
        catchError(() => {
          return of({ embDocks: [] })
        })
      ).subscribe(
        (response) => {
          this.embDocks = response.embDocks
            .map(d => ({
              ...d,
              status: new Date(d.status + 'Z')
            }))
            .sort((a: any, b: any) => {
              return a.description?.localeCompare(b.description);
            });
        }
      )
  }

  changeDockPage() {
    if (this.selectedDock !== null) {
      this.config = false;
      this.router.navigate([`/view/emb/dock/${this.selectedDock}`]);
    }
  }
}
